import * as types from '../../actions/actionTypes';
import initialState from './../initialState';


export default function galleryImageReducer(state = initialState.galleryImage, action) {
    let newState;

    switch (action.type) {
        case types.GET_GALLERY_IMAGE_SUCCESS:
            return action.galleryImage;
        case types.UPDATE_GALLERY_IMAGE_SUCCESS:
            newState = {...state};
            newState.data = [
                ...newState.data.filter(galleryImage => galleryImage.id !== action.galleryImage.id),
                Object.assign({}, action.galleryImage)
            ];
            return newState;
            break;
        case types.RESET_GALLERY_IMAGE:
            return {...initialState.galleryImage};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/gallery/galleryImageReducer.js